module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9IjGi"))).then(() => parcelRequire('d0iPb'));